export const ttlockConfig = {
  credentials: {
    title: "إعداد TTLock",
    subtitle: "أدخل بيانات اعتماد حساب TTLock الخاص بك",
    savedBadge: "تم حفظ بيانات الاعتماد",
    noneBadge: "لا توجد بيانات اعتماد",
    emailLabel: "البريد الإلكتروني لحساب TTLock",
    emailPlaceholder: "you@example.com",
    emailHelp: "البريد الإلكتروني الذي تستخدمه لتسجيل الدخول إلى TTLock",
    passwordLabel: "كلمة المرور",
    passwordPlaceholderSaved: "•••••••• (محفوظة، يمكنك تغييرها اختياريًا)",
    passwordPlaceholder: "كلمة مرور TTLock الخاصة بك",
    passwordHelpSaved: "يمكنك تركها فارغة إذا كانت لديك واحدة محفوظة.",
    passwordHelp: "كلمة مرور حساب TTLock الخاص بك.",
    testing: "جارٍ الاختبار...",
    testConnection: "اختبار الاتصال",
    saving: "جارٍ الحفظ...",
    saveCredentials: "حفظ بيانات الاعتماد",
  },
  selector: {
    title: "محدِّد الأقفال لهذا العقار",
    subtitleBefore: "اختر فقط الأقفال التي تخص ",
    subtitleStrong: "هذا العقار",
    subtitleAfter: ".",
    selectedCount: "{count} محدَّد | {count} محدَّدة",
    hintBefore: "أدخل بيانات الاعتماد واضغط ",
    hintStrong: "اختبار الاتصال",
    hintAfter: " لتحميل أقفالك.",
    noneFound: "لم يتم العثور على أقفال. تحقق من حساب TTLock الخاص بك.",
    placeholder: "اختر الأقفال…",
    summaryCount: "{count} قفل محدَّد | {count} أقفال محدَّدة",
    emptySelection: "لم يتم تحديد أي قفل",
    saving: "جارٍ الحفظ...",
    save: "حفظ أقفال هذا العقار",
  },
  gateway: {
    with: "مع بوابة",
    without: "بدون بوابة",
  },
  pms: {
    title: "التحكم والتعيين (PMS)",
    subtitleP1: "عيّن كل قفل إلى ",
    subtitleStrongMain: "الباب الرئيسي",
    subtitleP2: " أو ",
    subtitleStrongUnit: "وحدة",
    subtitleP3: ".",
    assignedCount: "{count} معيَّن | {count} معيَّنة",
    empty: "ليس لديك أي أقفال محفوظة لهذا العقار بعد.",
    assignmentLabel: "التعيين",
    assignmentNone: "غير معيَّن",
    assignmentCommon: "الباب الرئيسي (مشترك)",
    assignmentUnit: "باب الشقة",
    hintNone: "لن يتم التحكم بها من نظام PMS.",
    hintAssigned: "سترتبط بهذا العقار للتحكم/رموز PIN.",
    unitLabel: "الوحدة / مكان الإقامة",
    unitSelectPlaceholder: "اختر وحدة",
    unitHint: "اختر الوحدة التي يفتحها هذا القفل.",
    nameLabel: "الاسم (اختياري)",
    namePlaceholder: "مثال: الباب الرئيسي / شقة 101",
    saving: "جارٍ الحفظ...",
    save: "حفظ التعيين",
  },
  actions: {
    lock: "إقفال",
    unlock: "فتح",
    requiresGateway: "يتطلب بوابة",
    createPasscode: "إنشاء رمز مرور",
    passcodeHistory: "سجل رموز المرور",
    refreshStatus: "تحديث الحالة",
  },
  lockFallbackName: "قفل {id}",
  unitFallbackName: "وحدة {id}",
  history: {
    title: "سجل رموز المرور",
    revocationTitle: "حول إلغاء الرموز:",
    withGatewayLabel: "مع البوابة:",
    withGatewayText: "يُلغى الرمز فورًا على القفل الفعلي.",
    withoutGatewayLabel: "بدون بوابة:",
    withoutGatewayText:
      "يُحذف الرمز من خادم TTLock، لكنه سيظل يعمل على القفل حتى يتصل شخص ما عبر البلوتوث من تطبيق الجوال ويزامن.",
    loading: "جارٍ تحميل السجل…",
    empty: "لا توجد رموز مرور مسجَّلة لهذا القفل.",
    colAlias: "الاسم المستعار",
    colPasscode: "رمز المرور",
    colValidity: "الصلاحية",
    colStatus: "الحالة",
    createdAt: "أُنشئ: {date}",
    fromLabel: "من:",
    toLabel: "إلى:",
    revokedTitle: "أُلغي بالفعل",
    revokeTitle: "حذف / إلغاء رمز المرور",
    close: "إغلاق",
  },
  passcodeModal: {
    title: "إنشاء رمز مرور مؤقت",
    nameLabel: "الاسم / التسمية",
    namePlaceholder: "مثال: التنظيف / نزيل / فنّي",
    nameHint: "سيساعدك هذا الاسم على تحديد الرمز.",
    validFrom: "صالح من",
    validTo: "صالح حتى",
    importantLabel: "هام:",
    importantText:
      "سيُنشأ الرمز تلقائيًا بواسطة TTLock وسيكون متاحًا فقط خلال الفترة المحددة. يمكن للنزيل إدخال هذا الرمز مباشرة على لوحة مفاتيح القفل (يعمل بدون إنترنت).",
    noGatewayLabel: "بدون بوابة:",
    noGatewayText:
      "هذا القفل غير متصل ببوابة. ستعمل الرموز المُنشأة بشكل ممتاز على لوحة المفاتيح الفعلية، لكن لن تتمكن من إلغائها عن بُعد من هذه اللوحة. للإلغاء، عليك القيام بذلك من تطبيق TTLock عبر الاتصال بالبلوتوث.",
    cancel: "إلغاء",
    creating: "جارٍ الإنشاء...",
    create: "إنشاء رمز مرور",
  },
  states: {
    active: "نشط",
    upcoming: "قادم",
    expired: "منتهٍ",
    revoked: "مُلغى",
    noDate: "بدون تاريخ",
  },
  confirm: {
    revoke:
      'هل أنت متأكد أنك تريد إلغاء/حذف رمز المرور "{alias}"؟\n\nملاحظة: إذا لم يكن للقفل بوابة، فقد يكون الإلغاء جزئيًا فقط.',
  },
  toast: {
    noLocksFound: "لم يتم العثور على أقفال في TTLock.",
    loadStatusError: "تعذّر تحميل حالة الأقفال",
    loadStatusErrorGeneric: "خطأ في تحميل حالة الأقفال",
    credentialsRequired: "يجب إدخال اسم المستخدم وكلمة المرور أو أن تكون لديك بيانات اعتماد محفوظة.",
    connectionOk:
      "تم الاتصال بنجاح. تم العثور على {count} جهاز. | تم الاتصال بنجاح. تم العثور على {count} أجهزة.",
    testError: "خطأ أثناء اختبار الاتصال",
    credentialsSaved: "تم حفظ بيانات الاعتماد بنجاح",
    saveCredentialsError: "خطأ في حفظ بيانات الاعتماد",
    saveCredentialsErrorDetail: "خطأ في حفظ بيانات الاعتماد: {msg}",
    selectAtLeastOne: "يجب اختيار جهاز واحد على الأقل لهذا العقار.",
    devicesSaved: "تم حفظ الأجهزة لهذا العقار",
    devicesSaveError: "تعذّر حفظ الأجهزة",
    saveErrorDetail: "خطأ في الحفظ: {msg}",
    unitRequired: "اختر الوحدة للأقفال المعيَّنة على أنها 'باب الشقة'.",
    bindingsSaved: "تم حفظ التعيين بنجاح",
    bindingsSaveError: "تعذّر حفظ التعيين",
    bindingsSaveErrorDetail: "خطأ في حفظ التعيين: {msg}",
    assignFirst: "عيّن القفل أولًا (الباب الرئيسي أو الوحدة) واحفظ لتفعيل التحكم.",
    passcodeNameRequired: "يجب إدخال اسم/تسمية لرمز المرور.",
    passcodeDatesRequired: "يجب إدخال تاريخ الصلاحية من وإلى.",
    passcodeCreated: "تم إنشاء رمز المرور: {code}",
    passcodeCreateError: "تعذّر إنشاء رمز المرور",
    passcodeCreateErrorGeneric: "خطأ في إنشاء رمز المرور",
    lockLocked: "تم إقفال القفل",
    lockLockError: "تعذّر الإقفال",
    lockLockErrorGeneric: "خطأ في الإقفال",
    lockUnlocked: "تم فتح القفل",
    lockUnlockError: "تعذّر الفتح",
    lockUnlockErrorGeneric: "خطأ في الفتح",
    revokeNoProviderId: "رمز المرور هذا لا يحتوي على provider_passcode_id. لا يمكن إلغاؤه في TTLock.",
    revokedOk: "تم إلغاء رمز المرور بالكامل",
    revokeError: "تعذّر الإلغاء",
    revokeErrorGeneric: "خطأ في إلغاء رمز المرور",
    historyLoadError: "تعذّر تحميل السجل",
    historyLoadErrorGeneric: "خطأ في تحميل السجل",
  },
};
